import './MyButton.scss';

const MyButton = ({ name, grey, width, height, size, data, blue, type = "button", onClick }) => {

  const handleClick = (e) => {
    if (data) data(e);
    if (onClick) onClick(e);
  };

  return (
    <button
      type={type}
      className='MyButton'
      style={{
        background: grey ? 'var(--surface-muted)' : blue ? 'var(--color-accent)' : 'var(--color-brand-fill)',
        width,
        height,
        color: grey ? 'var(--color-text)' : blue ? 'var(--color-on-accent)' : 'var(--color-on-brand)',
        fontSize: size || ''
      }}
      onClick={handleClick}
    >
      {name}
    </button>
  );
}

export default MyButton;